import type { ApiError } from "../types/api";

type ErrorCardProps = {
  error: ApiError["error"];
  onRetry?: () => void;
};

export function ErrorCard({ error, onRetry }: ErrorCardProps) {
  return (
    <section className="result-card error-card" role="alert">
      <h2>Verdict interrupted</h2>
      <p>{error.message}</p>
      {error.retryable && onRetry ? (
        <button type="button" className="secondary-button" onClick={onRetry}>
          Run it back
        </button>
      ) : null}
    </section>
  );
}
